
import { mapActions, mapState } from 'vuex';
import { max } from '~/services/validators';
import formMixin from '~/services/form';
import promiseErrors from '~/services/promiseErrors';

/* eslint vue/no-v-html: 0 */
export default {
    name: 'ReportView',
    mixins: [formMixin],
    async asyncData({ app, error, route }) {
        const [comments, data] = await promiseErrors(
            [
                app.$axios.$get(`${app.$config.endpoints.report}/${route.params.id}/comment`),
                app.$axios.$get(`${app.$config.endpoints.report}/${route.params.id}`),
            ],
            app,
        );

        if (!data) {
            return error({ statusCode: 404, message: app.i18n.t('flytipping.not_found') });
        }

        const [group, reports] = await promiseErrors(
            [
                app.$axios.$get(`${app.$config.endpoints.groupNearby}`, {
                    params: {
                        per_page: 1,
                        lat: data.report.lat,
                        lon: data.report.lon,
                    },
                }),
                app.$axios.$get(app.$config.endpoints.reportNearby, {
                    params: {
                        per_page: 3,
                        lat: data.report.lat,
                        lon: data.report.lon,
                        report_id: data.report.id,
                    },
                }),
            ],
            app,
        );

        return {
            comments: data ? comments.comments.data : [],
            council: data ? data.report.council : {},
            report: data ? data.report : {},
            reports: reports ? reports.reports.data : [],
            group: group ? group.groups.data[0] : {},
        };
    },
    data() {
        return {
            comments: [],
            council: null,
            group: null,
            rejectedReason: '',
            report: {},
            reportableEndpoint: `${this.$config.endpoints.report}/${this.$route.params.id}/report`,
            reports: [],
            showMenu: false,
            showOwnerMenu: false,
        };
    },
    head() {
        return {
            title: `${this.$t('flytipping.flytipping_in', { location: this.displayAddress })} - ClearWaste`,
            meta: [
                { hid: 'description', name: 'description', content: this.report.description.substring(0, 150) },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: `${this.$t('flytipping.flytipping_in', { location: this.displayAddress })} - ClearWaste`,
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: this.report.description.substring(0, 150),
                },
                {
                    hid: 'og:image',
                    property: 'og:image',
                    content: this.report.images[0].large,
                },
                {
                    hid: 'og:url',
                    property: 'og:url',
                    content: `${this.$config.domain}${this.$route.path}`,
                },
            ],
        };
    },
    computed: {
        ...mapState(['auth', 'isMobile']),
        displayAddress() {
            let address = '';
            if (this.report.road) {
                address += `${this.report.road.name}, `;
            }
            if (this.report.city) {
                address += this.report.city.name;
            }

            return address;
        },
        mapRoute() {
            const params = {
                name: 'flytipping-map-type',
                params: {
                    type: 'city',
                },
                query: {
                    lat: this.report.lat,
                    lng: this.report.lon,
                },
            };

            if (this.report.cleared_at) {
                params.query.closed = 1;
            }

            return params;
        },
        isOwner() {
            return (this.auth.user && this.report.user_id === this.auth.user.id) || (this.auth.user && this.auth.user.role === 'admin');
        },
        reportClosed() {
            return !!this.report.cleared_at || !!this.report.rejected_at;
        },
    },
    methods: {
        ...mapActions(['showReportable']),
        deleteReport() {
            this.$axios.$delete(`${this.$config.endpoints.report}/${this.$route.params.id}`).then(({ message }) => {
                this.$store.dispatch('setFlashMessage', { message });
                this.$router.push({ name: 'dashboard' });
            });
        },
        async rejectReport() {
            const { message } = await this.$form.submit(`${this.$config.endpoints.report}/${this.$route.params.id}/reject`, 'post', {
                ...(this.rejectedReason && { reason: this.rejectedReason }),
            });
            this.$store.dispatch('setFlashMessage', { message });
            this.$router.push({ name: 'dashboard' });
        },
        markCleared() {
            this.$axios
                .$post(`${this.$config.endpoints.report}/${this.$route.params.id}/clear`, {
                    cleared: true,
                })
                .then(({ message }) => {
                    this.report.cleared_at = this.$t('common.just_now');
                    this.$store.dispatch('setFlashMessage', { message });
                });
        },
        showBottomSheet() {
            this.showMenu = !this.showMenu;
            this.showOwnerMenu = !this.showOwnerMenu;
        },
        updateAssigned(user) {
            if (user) {
                this.report.assigned_user = user;
                this.report.assigned_user_id = user.id;
            } else {
                this.report.assigned_user = null;
                this.report.assigned_user_id = null;
            }
        },
    },
    validations: {
        rejectedReason: [{ validator: max, length: 250 }],
    },
};
